export default __webpack_public_path__ + "static/media/2.e9a87367.png";